import type { FC } from "react";
import { MdCommentsDisabled } from "react-icons/md";
import type { EmailData } from "../../../../common/src/types/types";
import "../styles/EmailCard.css";

interface EmailCardProps {
    email: EmailData;
    selected?: boolean;
    onSelect: (email: EmailData) => void;
    formatDate: (date: Date) => string;
}

const EmailCard: FC<EmailCardProps> = ({ email, selected = false, onSelect, formatDate }) => {
    const cardClassName = selected ? "email-card selected" : "email-card";
    return (
        <button type="button" className={cardClassName} onClick={() => onSelect(email)} title="Click to preview">
            <div className="email-card-header">
                <div className="email-card-title">
                    <span className="email-card-subject" title={email.subject}>{email.subject}</span>
                </div>
                <div className="email-card-status-wrap">
                    <span className="email-card-date">{formatDate(email.date)}</span>
                    <span className="email-card-status">
                        <span className={`status-dot ${email.archiveStatus ?? "Queued"}`}></span>
                        {email.archiveStatus ?? "Queued"}
                    </span>
                    {(email.bodyRemoved) && (
                        <span className="no-body-icon status-no-body" title="Email body not stored" aria-label="Email body not stored">
                            <MdCommentsDisabled size={16} />
                        </span>
                    )}
                </div>
            </div>
            <div className="email-card-meta">
                {(email.sender || email.recipient) && (
                    <>
                        <div title={email.sender}>
                            <span className="meta-label">From</span>
                            <span className="meta-value">{email.sender}</span>
                        </div>
                        <div title={email.recipient}>
                            <span className="meta-label">To</span>
                            <span className="meta-value">{email.recipient}</span>
                        </div>
                    </>
                )}
            </div>
        </button>
    );
};

export default EmailCard;
